import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  getInvitedCoderJobPostService,
  getJobByIdService,
  getJobsService,
  getRecommendedCoderJobPostService,
  inviteCoderService,
  patchInvitedCoderJobPostService,
  getLatestJobsService,
  getClientInviteJobService,
  getInvitedCodersByJobId
} from '../../services/jobs';

import * as type from '../ActionTypes';

import {
  createJobPost,
  getAllTechnologyService,
  updateJobPostService
} from '../../services/jobPost';
import {
  getApprovedTechnologies,
  getErrorMszOnFailure,
  successStatusCodeList
} from '../../helper/utils';
import { getJobByIdFailure, getJobByIdSucess } from '../actions/jobs';
import { inviteCoderFailure, inviteCoderSuccess } from '../actions/jobPost';
import { clientProfileDataByIdService } from '../../services/clientProfileData';
import { getProposalsByJobService } from '../../services/proposal';
import { getContractByJobIdService } from '../../services/contract';

function* getJobById(action: any): any {
  try {
    const job = yield call(getJobByIdService, action.id);
    yield put(getJobByIdSucess(job.data));
  } catch (e: any) {
    yield put(getJobByIdFailure(e.data.detail));
    console.warn(e.message);
  }
}

function* getJobs(action: any): any {
  try {
    const jobs = yield call(getJobsService, action.params);
    if (successStatusCodeList.includes(jobs.statusCode)) {
      yield put({
        type: type.GET_JOB_SUCCESS,
        jobs: jobs.data
      });
    } else {
      yield put({ type: type.GET_JOB_FAILURE, message: jobs.data?.error });
    }
  } catch (e: any) {
    yield put({ type: type.GET_JOB_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* getClientInfoByJobPost(action: any): any {
  try {
    const contract = yield call(getContractByJobIdService, action.params);
    const contractData = contract.data.results;

    const jobPostData = yield all(
      contractData.map((o: any) => call(getJobByIdService, o.job_post))
    );
    const clientData = yield all(
      contractData.map((o: any) => call(clientProfileDataByIdService, o.client_id))
    );

    if (
      jobPostData.length > 0 &&
      jobPostData[0].status === 200 &&
      jobPostData.length > 0 &&
      clientData[0].status === 200
    ) {
      const jobPostDataArr = jobPostData.map((o: any) => o.data);
      const clientDataArr = clientData.map((o: any) => o.data);

      const jobPost_clientData = jobPostDataArr.map((o: any, i: any) => ({
        ...o,
        contractId: contractData[i].id,
        clientData: clientDataArr.filter((cd: any) => cd.id == o.user)[0]
      }));

      yield put({
        type: type.GET_JOB_SUCCESS,
        jobs: { ...contract.data, results: jobPost_clientData }
      });
    } else {
      yield put({
        type: type.GET_JOB_SUCCESS,
        jobs: {}
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_JOB_FAILURE, message: e.message });
  }
}

function* getAllTechnology(): any {
  try {
    const technology = yield call(getAllTechnologyService);
    if (technology?.data) {
      const approvedTech = yield getApprovedTechnologies(technology.data);
      yield put({
        type: type.SET_ALL_TECHNOLOGY,
        technology: approvedTech
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_ALL_TECHNOLOGY_FAILURE, message: e.message });
  }
}

function* saveJobPost(action: any): any {
  try {
    const job = yield call(createJobPost, action.payload);
    if (job?.statusCode === 201) {
      yield put({
        type: type.JOB_CREATED_SUCCESSFULLY,
        job: job.data
      });
    } else {
      yield put({ type: type.JOB_CREATION_ERROR, message: 'Oops! Something went wrong' });
    }
  } catch (e: any) {
    yield put({
      type: type.JOB_CREATION_ERROR,
      message: 'Oops! Something went wrong'
    });
  }
}

function* updateJobPost(action: any): any {
  try {
    const job = yield call(updateJobPostService, action.payload, action.id);
    if (job?.statusCode === 201) {
      yield put({
        type: type.UPDATE_JOB_POST_SUCCESS,
        job: job.data
      });
      // yield call(getJobs);
    } else {
      yield put({ type: type.JOB_CREATION_ERROR });
    }
  } catch (e: any) {
    yield put({ type: type.JOB_CREATION_ERROR, message: e.message });
  }
}

function* patchInvitedCoderJobPostRequest(action: any): any {
  try {
    const patchInvitedCoder = yield call(
      patchInvitedCoderJobPostService,
      action.params.data,
      action.params.id
    );
    if (patchInvitedCoder.status === 200) {
      yield put({
        type: type.GET_INVITEDCODER_SUCCESS,
        proposal: patchInvitedCoder.data
      });
    } else {
      yield put({
        type: type.GET_INVITEDCODER_FAILURE,
        error: getErrorMszOnFailure(patchInvitedCoder.data) ?? 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_INVITEDCODER_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getInvitedCoderJobPostRequest(payload: any): any {
  try {
    const invitedCoder = yield call(getInvitedCoderJobPostService, payload.params);
    const invitedCoderData = invitedCoder.data.results.map((o: any) => ({
      ...o,
      ...o.job_post,
      invitedCoderJobId: o.id,
      invitedCoderStatus: o.status,
      clientData: o.client
    }));
    if (invitedCoderData.length > 0) {
      yield put({
        type: type.GET_INVITEDCODER_SUCCESS,
        invitedCoder: { ...invitedCoder?.data, results: invitedCoderData }
      });
    } else {
      yield put({ type: type.GET_INVITEDCODER_SUCCESS, invitedCoder: {} });
    }
  } catch (e: any) {
    yield put({ type: type.GET_INVITEDCODER_FAILURE });
  }
}

function* getRecommendedCoderJobPostRequest(payload: any): any {
  try {
    const recommendedCoder = yield call(getRecommendedCoderJobPostService, payload.params);
    const clientData = yield all(
      recommendedCoder.data.results.map((o: any) => call(clientProfileDataByIdService, o.user))
    );

    const jobPostDataArr = recommendedCoder?.data.results;
    const clientDataArr = clientData.map((o: any) => o.data);

    const jobPost_clientData = jobPostDataArr.map((o: any) => ({
      ...o,
      clientData: clientDataArr.filter((cd: any) => cd.id == o.user)[0]
    }));

    if (jobPost_clientData.length > 0) {
      yield put({
        type: type.GET_RECOMMENDEDCODER_SUCCESS,
        recommendedCoder: jobPost_clientData,
        allRecommendedCoder: recommendedCoder?.data
      });
    } else {
      yield put({
        type: type.GET_RECOMMENDEDCODER_SUCCESS,
        recommendedCoder: [],
        allRecommendedCoder: {}
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_INVITEDCODER_FAILURE });
  }
}

function* inviteCoders(action: any): any {
  try {
    const invitations = yield call(inviteCoderService, action.payload);
    if (invitations.status === 201) {
      yield put(inviteCoderSuccess(invitations.data));
      const getInvitations = yield call(getInvitedCodersByJobId, {
        jobpost: action.payload.jobpost
      });
      if (getInvitations.status === 200) {
        yield put({
          type: type.GET_ALL_INVITES_SUCCESS,
          data: getInvitations.data
        });
      }
    }
  } catch (e: any) {
    yield put(inviteCoderFailure(e.data.error));
  }
}
function* getTnviteCodersList(action: any): any {
  try {
    const getInvitations = yield call(getInvitedCodersByJobId, action.payload);
    if (getInvitations.status === 200) {
      yield put({
        type: type.GET_ALL_INVITES_SUCCESS,
        data: getInvitations.data
      });
    } else {
      yield put({
        type: type.GET_ALL_INVITES_FAILURE,
        error: getErrorMszOnFailure(getInvitations.data) ?? 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_ALL_INVITES_FAILURE });
  }
}
function* getAllJobRouteCount(action: any): any {
  try {
    if (action.params.status === 'ACCEPTED_BY_CODER') {
      const contract = yield call(getContractByJobIdService, {
        job_post: action.params.job_post
      });
      const contractData = contract.data.results;
      const completed = contractData[0].ended_by_client;
      yield put({
        type: type.GET_ROUTE_COUNT_SUCCESS,
        routeCount: completed
          ? `2__${contractData[0].id}__${action.params.budget_type}__${action.params.job_post}`
          : `5__${contractData[0].id}__${action.params.budget_type}__${action.params.job_post}`
      });
    }
    if (action.params.status === 'ACCEPTED_BY_CLIENT') {
      yield put({
        type: type.GET_ROUTE_COUNT_SUCCESS,
        routeCount: `3__${action.params.pId}__${action.params.budget_type}__${action.params.job_post}`
      });
    }
    if (action.params.status === 'SENT') {
      yield put({
        type: type.GET_ROUTE_COUNT_SUCCESS,
        routeCount: `4__${action.params.pId}__${action.params.budget_type}__${action.params.job_post}`
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_JOB_FAILURE });
  }
}

function* getClientInfoByLatestJobPost(action: any): any {
  try {
    const jobPostData = yield call(getLatestJobsService, action.params);
    const clientData = yield all(
      jobPostData.data.results.map((o: any) => call(clientProfileDataByIdService, o.user))
    );
    if (jobPostData.status === 200 && clientData[0].status === 200) {
      const jobPostDataArr = jobPostData.data.results;
      const clientDataArr = clientData.map((o: any) => o.data);

      const jobPost_clientData = jobPostDataArr.map((o: any) => ({
        ...o,
        clientData: clientDataArr.find((cd: any) => cd.id === o.user)
      }));

      yield put({
        type: type.GET_LATEST_JOB_SUCCESS,
        jobs: { ...jobPostData?.data, results: jobPost_clientData }
      });
    } else {
      yield put({
        type: type.GET_LATEST_JOB_FAILURE
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_LATEST_JOB_FAILURE, message: e.message });
  }
}

function* getClientInviteJob(): any {
  try {
    const jobs = yield call(getClientInviteJobService);
    if (jobs.status === 200) {
      yield put({
        type: type.GET_CLIENT_INVITE_JOB_SUCCESS,
        clientInviteJob: jobs?.data
      });
    } else {
      yield put({
        type: type.GET_CLIENT_INVITE_JOB_FAILURE,
        clientInviteJob: []
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_CLIENT_INVITE_JOB_FAILURE, message: e.message });
  }
}

function* jobsSaga() {
  yield takeEvery(type.GET_JOB_REQUEST_BY_ID, getJobById);
  yield takeEvery(type.GET_JOB_REQUEST, getJobs);
  yield takeEvery(type.GET_ALL_TECHNOLOGY, getAllTechnology);
  yield takeEvery(type.CREATE_JOB_POST, saveJobPost);
  yield takeEvery(type.UPDATE_JOB_POST_REQUEST, updateJobPost);
  yield takeEvery(type.GET_CLIENTINFO_BY_JOBPOST_REQUEST, getClientInfoByJobPost);
  yield takeEvery(type.GET_INVITEDCODER_REQUEST, getInvitedCoderJobPostRequest);
  yield takeEvery(type.PATCH_INVITEDCODER_REQUEST, patchInvitedCoderJobPostRequest);
  yield takeEvery(type.GET_RECOMMENDEDCODER_REQUEST, getRecommendedCoderJobPostRequest);
  yield takeEvery(type.GET_ROUTE_COUNT_REQUEST, getAllJobRouteCount);
  yield takeEvery(type.SEND_INVITE, inviteCoders);
  yield takeEvery(type.GET_LATEST_JOB_REQUEST, getClientInfoByLatestJobPost);
  yield takeEvery(type.GET_CLIENT_INVITE_JOB_REQUEST, getClientInviteJob);
  yield takeEvery(type.GET_ALL_INVITES, getTnviteCodersList);
}

export default jobsSaga;
